module.exports = __webpack_public_path__ + "static/media/p2.98e58129.png";